import { useProcurifyIntl } from '@webapp/hooks'
import { POPDFLabelSetNameForm } from '@webapp/modules/purchasing/components/POPDFLabelSetNameForm'
import { type PDFLabelSet } from '@webapp/modules/vendor/entities/PDFLabelSet' // eslint-disable-line import/no-internal-modules
import messages from './messages'
import { useCreatePOPDFLabelSetFormPresenter } from './useCreatePOPDFLabelSetFormPresenter'

export interface ICreatePOPDFLabelSetFormPresenterProps {
  /** Closes the FS-owned modal and makes the created set active (BHV-037). */
  onSuccess: (set: PDFLabelSet) => void
  onCancel: () => void
}

export const CreatePOPDFLabelSetFormPresenter = ({
  onSuccess,
  onCancel,
}: ICreatePOPDFLabelSetFormPresenterProps) => {
  const intl = useProcurifyIntl()

  const {
    states: { isSaving },
    handlers: { handleSubmit },
  } = useCreatePOPDFLabelSetFormPresenter({ onSuccess })

  return (
    <POPDFLabelSetNameForm
      submitButtonText={intl.formatMessage(messages.createButton)}
      isSaving={isSaving}
      onSubmit={handleSubmit}
      onCancel={onCancel}
    />
  )
}

CreatePOPDFLabelSetFormPresenter.displayName =
  'CreatePOPDFLabelSetFormPresenter'
